module.exports = __webpack_public_path__ + "img/fanni-tamas.d803562c.jpg";